import { render, staticRenderFns } from "./NetworkInfo.vue?vue&type=template&id=09b04606&scoped=true&"
import script from "./NetworkInfo.vue?vue&type=script&setup=true&lang=ts&"
export * from "./NetworkInfo.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./NetworkInfo.vue?vue&type=style&index=0&id=09b04606&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09b04606",
  null
  
)

export default component.exports